import React from "react";
import { Field } from "formik";

import styles from "./NameInput.module.scss";

import { FieldPropsType, NameInputPropsType } from "./types";

export const NameInput: React.FC<NameInputPropsType> = (props) => {
  const { name, focusThisInput = false, placeholder, lable } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    if (focusThisInput) {
      inputRef.current?.focus();
    }
  }, []);

  return (
    <Field name={name}>
      {(fieldProps: FieldPropsType) => {
        const { field, meta } = fieldProps;
        const hasValue = !!meta.value && meta.value.length > 0;
        const shouldShowLabelFocus = isFocused || hasValue;

        return (
          <div className={styles.inputWrapper}>
            <label
              htmlFor={name}
              className={`
                ${styles.label}
                ${shouldShowLabelFocus && styles.labelFocus}
              `}>
              {lable}
            </label>
            <input
              ref={inputRef}
              type="text"
              id={name}
              className={`
                ${styles.input}
                ${meta.touched && meta.error ? styles.error : null}
                ${shouldShowLabelFocus ? styles.inputFocus : null}
              `}
              {...field}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const val = e.target.value;
                const capitalized = val.replace(/(^|\s)\S/g, (ch) => ch.toUpperCase());
                e.target.value = capitalized;
                (field as any).onChange(e);
              }}
              onFocus={(e) => {
                setIsFocused(true);
                if ('onFocus' in field && typeof field.onFocus === 'function') {
                  field.onFocus(e);
                }
              }}
              onBlur={(e) => {
                setIsFocused(false);
                if ('onBlur' in field && typeof field.onBlur === 'function') {
                  field.onBlur(e);
                }
              }}
            />
          </div>
        );
      }}
    </Field>
  );
};
